(function() {

        const LOG_PREFIX = '[UpPromote ImageFix]';

        const CONTAINER_ID = 'up-cx-ref-image-container';



        function fixPicture(picture) {

            const mobileSource = picture.querySelector('source[media*="max-width"]');

            const img = picture.querySelector('img');

            if (!img) return false;



            if (mobileSource) mobileSource.remove();



            const desktopSrc = img.getAttribute('src');

            if (desktopSrc) {

                img.removeAttribute('srcset');

                img.src = desktopSrc;

            }

            return true;

        }



        function fixAll() {

            const container = document.getElementById(CONTAINER_ID);

            if (!container) return 0;

            let count = 0;

            container.querySelectorAll('picture').forEach(p => {

                if (fixPicture(p)) count++;

            });

            return count;

        }



        function start() {

            if (fixAll() > 0) {

                return;

            }



            const observer = new MutationObserver(() => {

                if (fixAll() > 0) {

                    console.log(LOG_PREFIX, 'Fixed after mutation');

                    observer.disconnect();

                }

            });

            observer.observe(document.body, { childList: true, subtree: true });

            setTimeout(() => observer.disconnect(), 15000);

        }



        if (document.readyState === 'loading') {

            document.addEventListener('DOMContentLoaded', start);

        } else {

            start();

        }

})();